module.exports = __webpack_public_path__ + "static/media/mappa-base.01198943.png";